.externalContent {
  position: absolute;
  inset: 0;
  z-index: 0; /* Create a stacking context so that children stack within this element. */
  pointer-events: none;
}
.externalContentFocusing {
  z-index: 1;
  background-color: #8888;
  pointer-events: all;
}

.container {
  position: relative;
  pointer-events: none;
  opacity: unset;
  z-index: unset;
}

.focusedContainer {
  /* Override potentially negative z from canvas ordering */
  z-index: 1 !important;
  pointer-events: all;
}

.disabledContainer {
  opacity: 0.5;
  z-index: 0 !important;
}
